import { Box, COLOR_PALETTE, Ellipsis, Radio, Text, Tooltip } from '@inflearn/ds-react';
import { Flex } from '@inflearn/ds-react';
import { memo } from 'react';

import type { AgreementValueType } from './useAgreementMap';
import { AGREEMENT_VALUES } from './useAgreementMap';

interface AgreementItemProps {
  id: number;
  leftText: string;
  onChange: (id: number, value: AgreementValueType) => void;
  selectedValue?: AgreementValueType;
}

const AgreementItem = ({ id, leftText, onChange, selectedValue }: AgreementItemProps) => (
  <Flex
    justify="space-between"
    px={16}
    py={10}
    gap={20}
    align="center"
    css={{ backgroundColor: COLOR_PALETTE.gray[0], borderRadius: 8 }}>
    <Tooltip label={leftText} withArrow position="top">
      <Box>
        <Ellipsis lineClamp={1}>
          <Text size="sm" weight="400" lh="1.3" css={{ wordBreak: 'break-all' }}>
            {leftText}
          </Text>
        </Ellipsis>
      </Box>
    </Tooltip>
    <Radio.Group
      css={{ flex: 'none' }}
      onChange={(value: AgreementValueType) => {
        onChange(id, value);
      }}
      value={selectedValue}>
      <Flex gap={10} align="center">
        <Radio
          label="동의"
          size="xs"
          color="infgreen"
          value={AGREEMENT_VALUES.AGREE}
          checked={selectedValue === AGREEMENT_VALUES.AGREE}
        />
        <Radio
          label="비동의"
          size="xs"
          color="infgreen"
          value={AGREEMENT_VALUES.DISAGREE}
          checked={selectedValue === AGREEMENT_VALUES.DISAGREE}
        />
      </Flex>
    </Radio.Group>
  </Flex>
);

export const MemoizedAgreementItem = memo(AgreementItem);
